import DPO from 'dpo8core';
import endpoint from '@app/endpoint';
import LoadingSvg from '@images/icons/loading.svg';
import ImageNotAvailableSvg from '@images/icons/image_not_available.svg';

async function applyFontMetrics(flowConfig) {
  const fontList = flowConfig.fonts.getAll();
  const fontMetricsURL = flowConfig.getResourceURL('dpo8-font-metrics');
  const fallbackFontFamilyName = flowConfig.fonts.getFallbackFont();
  const allMetrics = DPO.text.fontMetricsJson || await endpoint.fetchFontsData(fontMetricsURL);

  DPO.text.fontMetricsJson = allMetrics;
  DPO.text.fontMetricsAll = new DPO.text.FontMetrics({
    allMetrics,
    fallbackFontFamilyName,
  });
  DPO.text.fontMetricsDefault = new DPO.text.FontMetrics({
    allMetrics,
    fontList,
    fallbackFontFamilyName,
  });
}

const initLayoutManager = flowConfig => {
  let fontsURL = flowConfig.getResourceURL('dpo8-fonts');
  fontsURL += fontsURL[fontsURL.length - 1] !== '/' ? '/' : '';

  DPO.text.fontMetricsDefault.defineFontFaces(document, fontsURL);

  return new DPO.text.LayoutManager(fontsURL, DPO.text.fontMetricsDefault, {
    layoutMap: {
      shrinkwrap: 'layoutShrinkWrap',
      wrapshrink: 'layoutWrapShrink',
      wrap: 'layoutWrapShrink',
      shrink: 'layoutShrinkWrap',
      fit: 'layoutFit',
    },
  });
};

const injectImgLoadingSvg = () => {
  DPO.bll.HttpProjectStorage.prototype.loadingImgURL = LoadingSvg;
  DPO.bll.HttpProjectStorage.prototype.errorImgURL = ImageNotAvailableSvg;
};

const initConverter = flowConfig => new DPO.text.UnitConverter(flowConfig.locale);

export const loadFlowConfig = params =>
  new Promise((resolve, reject) =>
    endpoint.fetchFlowConfiguration(
      params,
      async flowConfig => {
        await applyFontMetrics(flowConfig);
        injectImgLoadingSvg();
        resolve({
          colorSpace: null,
          flowConfig: flowConfig,
          converter: initConverter(flowConfig),
          layoutManager: initLayoutManager(flowConfig),
        });
      },
      response => {
        reject(response);
      },
    ),
  );
